/**
 * All different types of items, that are accepted by DEXF.
 *
 * Note: Custom Kompis item types like bundles are not included in this enum.
 */
enum ItemTypeEnum {
	art = 'ART',
	spr = 'SPR',
	ext = 'EXT',
	asl = 'ASL',
	msc = 'MSC',
	asm = 'ASM',
	asp = 'ASP'
}

export default ItemTypeEnum;
